import { Capacitor, registerPlugin } from "@capacitor/core";

const DiditVerification = registerPlugin("DiditVerification");

export function canUseNativeDidit() {
  return Capacitor.getPlatform() === "android";
}

export async function startNativeDidit(sessionToken) {
  if (!canUseNativeDidit()) throw new Error("Didit nativa disponível apenas no Android.");
  return DiditVerification.start({ sessionToken });
}
